import { Box, SimpleGrid, Text, useColorModeValue } from '@chakra-ui/react';
import Card from '../../../components/card/Card';

function Information(props: { title: string; value: number | string; [x: string]: any; children?: React.ReactNode }) {
	const { title, value, children, ...rest } = props;
	const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
	const textColorSecondary = 'gray.400';
	const bg = useColorModeValue('white', 'navy.700');
	return (
		<Card bg={bg} {...rest}>
			<Box>
				<Text fontWeight='500' color={textColorSecondary} fontSize='sm'>
					{title}
				</Text>
				{children ? children : <Text color={textColorPrimary} fontWeight='500' fontSize='md'>
					{value}
				</Text>}
			</Box>
		</Card>
	);
}

type Props = {
	cardProps: { [x: string]: any };
	items: { title: string; content: string; overrideContent?: React.ReactNode }[];
	title?: string;
	description?: string;
};

export function GenericGeneralInformation({ cardProps, title, description, items }: Props) {
	const { ...rest } = cardProps;
	const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
	const textColorSecondary = 'gray.400';
	const cardShadow = useColorModeValue('0px 18px 40px rgba(112, 144, 176, 0.12)', 'unset');
	return (
		<Card mb={{ base: '0px', '2xl': '20px' }} {...rest}>
			{Boolean(title) && <Text color={textColorPrimary} fontWeight='bold' fontSize='2xl' mt='10px' mb='4px'>
				{title}
			</Text>}
			{description && <Text color={textColorSecondary} fontSize='md' me='26px' mb='40px'>
				{description}
			</Text>}
			<SimpleGrid columns={2} gap='20px'>
				{items.map(item => {
					return <Information boxShadow={cardShadow} title={item.title} value={item.content} children={item.overrideContent} />;
				})}
			</SimpleGrid>
		</Card>
	);
}
